import { useContextState } from "../../../../../../hooks/theme" 

const useStyles = ({ margin }: { margin?: boolean }) => {
    const { colors } = useContextState()

    return {
        container:{
            marginBottom: margin? '20px':'0px',
            color: colors.color13,
            padding: '16px 24px',
            //minWidth: '300px'
        },
        title: {
            fontSize: '14px',
            textAlign: 'center',
            color: 'primary.100',
            fontWeight: '700'
        },
        display: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: '8px'
        },
        number: {
            fontSize: '45px',
            textAlign: 'center',
        },
        text: {
            fontSize: '13px',
            textAlign: 'center',
            fontWeight: '700'
        }
        
    }
}

export { useStyles }